import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import './http';

const updateManifest = () => {
    const currentPath = window.location.pathname.split("/")[1] || ""; // ตรวจสอบ path ที่ถูกต้อง
    const nameMap = {
        "": "Home",
        Control_Room: "Control Room",
        SEWING_Efficiency: "Sewing Efficiency",
        LoadData_Sewing: "Load Data Sewing",
        Report_SewingPerformance: "Sewing Performance",
        SPFTracking: "SPF Tracking",
        EndLine: "End Line",
        CuttingDashboard: "Cutting Efficiency",
    };

    const manifest = {
        short_name: nameMap[currentPath] || "NDES-sub",
        name: nameMap[currentPath] || "NDES-sub nanyangtextile",
        // อัปเดต start_url เป็น URL ที่สามารถเข้าถึงได้จริง
        start_url: `${window.location.origin}${
            currentPath ? `/${currentPath}` : "/"
        }`,
        display: "standalone",
        theme_color: "#000000",
        background_color: "#ffffff",
    };

    // บันทึกการเปลี่ยนแปลงในไฟล์ manifest (ใช้ในระหว่าง build หรือให้ server เป็นคนจัดการการเปลี่ยนแปลง)
    const stringManifest = JSON.stringify(manifest);

    // ส่งค่าไปยังตัวจัดการ
    localStorage.setItem("dynamic-manifest", stringManifest);
};

updateManifest();

const loadManifest = () => {
    const savedManifest = localStorage.getItem("dynamic-manifest");
    if (savedManifest) {
        const parsedManifest = JSON.parse(savedManifest);
        // ดำเนินการเปลี่ยนแปลงค่าใน link rel="manifest"
        const manifestLink = document.querySelector('link[rel="manifest"]');
        if (manifestLink) {
            // ตั้งค่าหมายเลข URL ที่เป็นที่อยู่ที่ถูกต้อง
            manifestLink.href = `data:application/json;base64,${btoa(
                JSON.stringify(parsedManifest)
            )}`;
        }
    }
};

loadManifest();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
